import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ClinicalOnboardingService } from '../../services/clinical-onboarding.service';
import { ToastService } from '../../services/general/toast.service';

/**
 * DBEK-412 (feedback utente: "rendere possibile l'inserimento di un nuovo
 * documento anche nella scheda del clinico [...] che non comparirà tra i
 * documenti condivisi anche per quanto riguarda la tipologia 'Per singolo
 * clinico'"): crea un documento riservato a QUESTO candidato, senza passare
 * dalla gestione "Documenti condivisi" - niente ambito da scegliere (e'
 * implicitamente "solo per lui") e niente upload qui: una volta creato, il file
 * si carica con lo stesso controllo "Carica file" gia' in uso per i documenti
 * Per-singolo-clinico nella lista documenti del pannello di dettaglio.
 */
@Component({
  selector: 'app-modal-add-candidate-document',
  templateUrl: './modal-add-candidate-document.component.html',
  styleUrls: ['./modal-add-candidate-document.component.scss'],
  standalone: false,
})
export class ModalAddCandidateDocumentComponent {
  saving = false;
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ModalAddCandidateDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { surveyId: string | number; candidateId: number },
    private fb: FormBuilder,
    private clinicalOnboardingService: ClinicalOnboardingService,
    private toastService: ToastService,
    private translateService: TranslateService,
  ) {
    this.form = this.fb.group({
      title: ['', Validators.required],
      requires_upload: [false],
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.saving = true;
    const value = this.form.value;

    this.clinicalOnboardingService.createCandidateOwnedDocument(
      this.data.surveyId,
      this.data.candidateId,
      {
        title: value.title,
        requires_upload: value.requires_upload,
      },
      () => {
        this.saving = false;
        this.toastService.success(
          this.translateService.instant('generic.success'),
          this.translateService.instant('components.clinical-onboarding.clinician-detail.document-added'),
        );
        this.dialogRef.close(true);
      },
      () => {
        this.saving = false;
      },
    );
  }

  closeDialogue(): void {
    this.dialogRef.close();
  }
}
